module.exports = __webpack_public_path__ + "img/OBCINA CIRKULANE.ff7e8557.png";